<div class="confirmation-modal-container">
  <div class="custom-modal-header">
    <div class="title">{{ title | translate }}</div>
    <div class="close-button" (click)="close()"><i class="bi bi-x x-icon"></i></div>
  </div>
  <div class="custom-modal-content">
    <div [formGroup]="form" class="row form-wrapper">
      <div class="col-12">
        <app-select-form-field
        formControlName="id"
          [users]="false"
          [label]="'label.select_case' | translate"
          [items]="problemRecordService.cases"
          [bindValue]="'id'"
          [clearable]="true"
          [searchable]="true"
          (onSelectEvent)="onChangeCaseItem($event)"
          [externalSearch]="true"
          (onSearchEvent)="onSearchForCases($event)"
          (onScrollEvent)="onScrollCases($event)"
          (onOpenEvent)="onOpen()"
          (onClearEvent)="onClear()"
        ></app-select-form-field>
      </div>
    </div>
  </div>
  <div class="custom-modal-footer">
    <div class="submit-actions">
      <button class="btn secondary-button" (click)="confirm(false)">{{ notConfirmActionLabel | translate }}</button>
      <button [disabled]="!form.valid" class="btn primary-button" (click)="confirm(true)">{{ confirmActionLabel | translate }}</button>
    </div>
  </div>
</div>